import { render, staticRenderFns } from "./LoginAlternativo.vue?vue&type=template&id=7c0ae326&"
import script from "./LoginAlternativo.vue?vue&type=script&lang=js&"
export * from "./LoginAlternativo.vue?vue&type=script&lang=js&"
import style0 from "./LoginAlternativo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports